import React from "react";
import { useRouter } from "next/router";

export default function BidderData(props: any) {
  const router = useRouter();
  const { for_event } = router.query;
  return (
    <div className="w-full mt-8 pb-4 flex">
      <label className="block text-sm font-medium text-gray-800 mb-4 mr-5">
        <span className="font-bold">Auction ID: </span>
        {for_event}
      </label>
      <label className="block text-sm font-medium text-gray-800 mb-4 mr-5">
        <span className="font-bold"> Email: </span>
        {props.data?.email}
      </label>
      <label className="block text-sm font-medium text-gray-800 mb-4 mr-5">
        <span className="font-bold"> KYC Verified: </span>
        {props.data?.kyc_verified ? "Yes" : "No"}
      </label>
      <label className="block text-sm font-medium text-gray-800 mb-4 mr-5">
        <span className="font-bold"> Approved: </span>
        {props.data?.status === "verified" ? "Yes" : "No"}
      </label>
    </div>
  );
}
